// @ts-strict-ignore
import type { PropsWithChildren } from 'react';
import React, {
  useState,
  useEffect,
} from 'react';
import { Text } from '@usealloy/component-library';
import { StyledPasswordValidation } from './styles';

interface Props {
  inputValue: string;
  setValidChecks: (value: boolean) => void;
}


const PasswordValidationList = ({ inputValue, setValidChecks }: PropsWithChildren<Props>) => {
  const [passwordValidation, setPasswordValidation] = useState({
    minChar: false,
    lowercase: false,
    uppercase: false,
    numeral: false,
    specialChar: false,
  });

  useEffect(() => {
    setPasswordValidation({
      minChar: inputValue && inputValue.length >= 8,
      lowercase: !!inputValue.match('[a-z]'),
      uppercase: !!inputValue.match('[A-Z]'),
      numeral: !!inputValue.match('[0-9]'),
      specialChar: !!inputValue.match('[-@#$%^&!.,*_]'),
    });
  }, [inputValue]);

  useEffect(() => {
    const allCriteriasMet = Object.values(passwordValidation).every(criteria => criteria === true);
    setValidChecks(allCriteriasMet);
  }, [passwordValidation, setValidChecks]);

  return (
    <StyledPasswordValidation>
      <Text as="p" size={3} className="pwMustContain">Your password must contain</Text>
      <Text as="p" className={`${passwordValidation.minChar ? 'valid' : 'invalid'} validationItem`}>At least 8 characters long</Text>
      <Text as="p" className={`${passwordValidation.lowercase ? 'valid' : 'invalid'} validationItem`}>Lower case letter</Text>
      <Text as="p" className={`${passwordValidation.uppercase ? 'valid' : 'invalid'} validationItem`}>Upper case letter</Text>
      <Text as="p" className={`${passwordValidation.numeral ? 'valid' : 'invalid'} validationItem`}>Number</Text>
      <Text as="p" className={`${passwordValidation.specialChar ? 'valid' : 'invalid'} validationItem`}>Special character</Text>
      <Text as="p" className="mustBeDiff">Must be different from the previous four passwords</Text>
    </StyledPasswordValidation>
  );
};

export default PasswordValidationList;
